import { ProfileCard } from "@/pages/profile/components/atom";
import styled from "styled-components";
import { MemberSystem } from "@/pages/profile/components/profile-charge-card/components/member-system";
import { useGlobalStore } from "@/store/GlobalStore";
import { BaseUnitPrice } from "@/pages/profile/components/profile-charge-card/components/charge-small-card/base-unit-price";
import { CouponCard } from "@/pages/profile/components/profile-charge-card/components/charge-small-card/coupon-card";
import { PicturePriceCard } from "@/pages/profile/components/profile-charge-card/components/charge-small-card/picture-price-card";
import { PictureLever, Zone } from "project-config/constants/user-info";
import { useTranslation } from "react-i18next";
import routerUtil from "@/utils/routerUtil";
import { CouponType } from "@/pages/coupon/constant";
import { useVocherInfo } from "@/pages/profile/hooks/useVocherInfo";
import { CreditCard } from "./components/charge-small-card/creadit-card";

export const toCoupon = (key: CouponType, path?: string) => {
  routerUtil.navigate?.(path || "/coupon", {
    state: {
      key,
    },
  });
};

export function ProfileChargeCard() {
  const {
    userInfo,
    isSubAccount,
    currencySymbol,
    isPictureUser,
    userCouponCount,
    userCouponPrice,
    isDomestic,
    isHideBalance,
    userCredit,
    userLevel,
    isHideJobCharge,
    isShowCreditTotal,
  } = useGlobalStore();
  const { vocherInfo, recentExpireDate } = useVocherInfo();

  const { t } = useTranslation("profile");

  const getProcessStatus = (userLevel: number) => {
    return userLevel <= 58;
  };
  const toTopUp = (activeName?: string) => {
    const basename =
      process.env.NODE_ENV === "development" ? "/topUp" : "/center/user/topUp";
    window.open(
      activeName ? `${basename}?activeName=${activeName}` : basename,
      "_blank"
    );
  };

  return (
    <ProfileCard className="charge-card">
      <ProfileChargeRow className="charge-item-row">
        {!isHideBalance && (
          <FinanceDataWrapper>
            {isPictureUser ? (
              <MemberSystem
                level={userInfo?.pictureLever === PictureLever.Member ? 1 : 0}
                showProgress={false}
                chargeClick={(key?: string) => toTopUp(key)}
                disabledRecharge={!isSubAccount}
              />
            ) : (
              <MemberSystem
                level={userLevel}
                showProgress={getProcessStatus(userLevel)}
                showTotal={(userLevel || 0) < 58}
                chargeClick={(key?: string) => toTopUp(key)}
                disabledRecharge={!isSubAccount}
              />
            )}
          </FinanceDataWrapper>
        )}
      </ProfileChargeRow>

      <ProfileChargeRow className="small-card-row">
        {(isShowCreditTotal || userCredit !== 0) && !isHideBalance && (
          <CreditCard
            currencySymbol={currencySymbol}
            userCredit={userCredit}
            totalCredit={userInfo?.totalCredit}
            isSubAccount={isSubAccount}
          />
        )}
        <ProfileFinanceCardWrapper>
          {!isPictureUser && (!isSubAccount || !isHideJobCharge) && (
            <BaseUnitPrice
              symbol={currencySymbol}
              cpuPrice={userInfo?.cpuPrice || 0}
              gpuPrice={userInfo?.gpuPrice || 0}
              priceUnit={
                userInfo?.zone === Zone.Domestic
                  ? { cpu: t("cpu_price_unit_new"), gpu: t("gpu_price_unit") }
                  : { cpu: t("cpu_price_unit_new"), gpu: t("gpu_price_unit") }
              }
            />
          )}
          {isPictureUser && (
            <>
              <PicturePriceCard
                title={t(`picture_normal_unit_price_${userInfo?.pictureLever}`)}
                symbol={currencySymbol}
                price={
                  userInfo?.pictureLever === PictureLever.Member ? 0.03 : 0.04
                }
                unit={t("picture_normal_unit_new_label")}
              />
              <PicturePriceCard
                title={t(`picture_normal_max_price_${userInfo?.pictureLever}`)}
                symbol={currencySymbol}
                price={userInfo?.pictureLever === PictureLever.Member ? 20 : 25}
                unit={t("picture_normal_max_label")}
              />
            </>
          )}
        </ProfileFinanceCardWrapper>
        {!isHideBalance && (
          <ProfileFinanceCardWrapper>
            <CouponCard
              coupon={t("render_coupon")}
              symbol={currencySymbol}
              price={userCouponPrice}
              total={userCouponCount}
              onClickDetail={() => toCoupon(CouponType.Animation)}
            />
            {!isPictureUser && isDomestic && (
              <CouponCard
                coupon={t("green_cloud_coupon")}
                symbol={currencySymbol}
                price={userInfo?.qyCoupon || 0}
                total={userInfo?.qyCouponCount || 0}
                onClickDetail={() => toCoupon(CouponType.Qing)}
              />
            )}
            {isPictureUser && (
              <CouponCard
                className="vocher"
                coupon={t("vocher_coupon")}
                symbol={t("picture_vocher_recent_exipre")}
                price={recentExpireDate}
                total={vocherInfo?.effectiveVoucher.length || 0}
                onClickDetail={() => toCoupon(CouponType.RenderingMember)}
              />
            )}
          </ProfileFinanceCardWrapper>
        )}
      </ProfileChargeRow>
    </ProfileCard>
  );
}

const FinanceDataWrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  @media (max-width: 1440px) {
    gap: 10px;
  }
`;

const ProfileChargeRow = styled.div`
  display: flex;
  align-items: center;
  margin-top: 24px;
  &.charge-item-row {
    align-items: unset;
    gap: 16px;
    margin-top: unset;
  }
  &.small-card-row {
    gap: 12px;
    margin-top: 12px;
    flex-wrap: wrap;
    @media (max-width: 1440px) {
      margin-bottom: 24px;
    }
  }
`;

const ProfileFinanceCardWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  width: 100%;
  @media (max-width: 1440px) {
    flex: unset;
    width: 100%;
  }
`;
